import React, { useState } from 'react';

import { useIsDesktop } from '@eika/hooks/src/useViewType';
import { Icon, IconTypes } from '@eika/icon';
import { ListPanel } from '@eika/link-panel';

import piwik from '@/piwik/piwik';

import { CreditCard, CreditCardAccount } from '@generated-types';
import useText from '@hooks/use-text';

import CardDetailsModal from './card-details-modal/CardDetailsModal';

interface CardDetailsProps {
    card: CreditCard;
    account: CreditCardAccount;
}

export const CardDetails = ({ card, account }: CardDetailsProps) => {
    const text = useText();

    const [showCardDetailsModal, setShowCardDetailsModal] = useState<boolean>(false);

    const isDesktop = useIsDesktop();

    if (isDesktop) {
        return null;
    }

    return (
        <>
            <ListPanel
                data-track-id={piwik.cardDetails.cardFunctionalityCardDetailsModalOpen.dataTrackId}
                data-track-linkname={piwik.cardDetails.cardFunctionalityCardDetailsModalOpen.dataTrackLinkname}
                icon={IconTypes.PIL_HOEYRE}
                prefixContent={<Icon type={IconTypes.INFO_24} />}
                id="card-details-modal-open"
                className="card-panel-functionality--card-details-modal-button"
                title={text.cardLinkCardDetails}
                backgroundColor="light"
                onClick={(e) => {
                    e.preventDefault();
                    setShowCardDetailsModal(true);
                }}
            />
            <CardDetailsModal
                id="card-details-modal"
                card={card}
                account={account}
                open={showCardDetailsModal}
                setOpen={() => setShowCardDetailsModal(false)}
                shouldCloseOnOverlayClick
            />
        </>
    );
};
